import React from 'react'
import { useTranslation } from 'react-i18next'

import { FormikErrors, useFormik } from 'formik'

import { GeneralSettings } from '../../data'
import { FormValues } from './general-data'
import { GeneralView } from './general-view'

type Props = {
  data: GeneralSettings | undefined
  handleSubmit: (formData: FormValues) => Promise<void>
  isRequestRunning: boolean
}

export const GeneralForm: React.FC<Props> = ({
  data,
  handleSubmit,
  isRequestRunning,
}) => {
  const { t } = useTranslation()

  // formik
  const formik = useFormik<FormValues>({
    enableReinitialize: true,
    initialValues: {
      isMalwareScanningActive: data?.isMalwareScanningActive || false,
    },
    validate: data => {
      let errors: FormikErrors<FormValues> = {}

      return errors
    },
    onSubmit: async (formData: FormValues) => {
      handleSubmit(formData)
    },
  })

  return <GeneralView formik={formik} isRequestRunning={isRequestRunning} />
}
